/**
 * Скачивает файл по ссылке
 * @param href - ссылка на файл
 * @param filename - имя файла (без расширения)
 * @param target - таргет для ссылки (по умолчанию - в новом окне)
 */
export default function downloadFile(href, filename, target = '_blank') {
    const linkDOM = document.createElement('a');
    linkDOM.href = href;
    linkDOM.download = filename;
    linkDOM.target = target;
    linkDOM.click();
}
